var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128044(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128-044-1,.cls-128-044-3{fill:#fff;}.cls-128-044-2,.cls-128-044-4,.cls-128-044-6{fill:none;}.cls-128-044-2,.cls-128-044-4{stroke:#6e6e6e;}.cls-128-044-2,.cls-128-044-3,.cls-128-044-4{stroke-linecap:round;stroke-width:1.25px;}.cls-128-044-2,.cls-128-044-3{stroke-linejoin:round;}.cls-128-044-3{stroke:#ff6a10;}.cls-128-044-4{stroke-miterlimit:10;}.cls-128-044-5{fill:#969696;}.cls-128-044-6{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-044-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-128-044-2",
    x1: 89.79,
    y1: 32.28,
    x2: 89.77,
    y2: 56.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M89.73,85.47l0,18.24a4.9,4.9,0,0,1-4.9,4.89l-41.39,0a4.89,4.89,0,0,1-4.89-4.9l0-18.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M38.58,56.56l0-33.16a4.9,4.9,0,0,1,4.91-4.89l32.51,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-044-2",
    x1: 89.51,
    y1: 95.8,
    x2: 38.57,
    y2: 95.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-044-2",
    x1: 38.59,
    y1: 24.41,
    x2: 76.04,
    y2: 24.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M67.7,101.87a3.53,3.53,0,1,1-3.53-3.53A3.53,3.53,0,0,1,67.7,101.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-3",
    d: "M109.55,15.31V27.64a4.57,4.57,0,0,1-4.46,4.66H88.71l-4.87,5.76a.38.38,0,0,1-.64-.26V32.3H80.49A4.56,4.56,0,0,1,76,27.64V15.31a4.56,4.56,0,0,1,4.45-4.66h24.6A4.57,4.57,0,0,1,109.55,15.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M76.54,81.69c3.31-2.2,5.4-6.85,5.4-16.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M47.66,65c0,9.83,2.09,14.48,5.4,16.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M81.64,53.56C80.79,43,77.5,34.63,64.8,34.63S48.81,43,48,53.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-4",
    d: "M60.4,73.18V76.8a2.76,2.76,0,0,1-1.71,2.55c-2,.82-4.36,1.8-5.92,2.46-3.49,1.48-5.67,4.65-5.67,6.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-4",
    d: "M82.5,88.28c0-1.89-2.18-5-5.67-6.47-1.56-.66-3.93-1.64-5.92-2.46A2.76,2.76,0,0,1,69.2,76.8V73.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M75.05,81.06a10.68,10.68,0,0,1-20.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M51.37,53.56c0-.39,0-.79,0-1.19,0-.16,0-.32,0-.48,1-1.34,2.87-2.68,4.39-6.43,0,0,6.45,6.56,22.48,7.44,0,.23,0,.45,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M77.11,63.38a15.19,15.19,0,0,1-2.77,5.45c-2.51,3.18-6.66,5.58-9.54,5.58S57.34,72,55.09,68.83a18.85,18.85,0,0,1-2.71-6.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-5",
    d: "M55.76,57.2a1.72,1.72,0,1,0,1.72-1.72A1.72,1.72,0,0,0,55.76,57.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-044-5",
    cx: 72.12,
    cy: 57.2,
    r: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M67.86,66.25c0,.94-1.55,2.07-2.61,2.07s-2.62-1.13-2.62-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M64.63,58.87l-.43,2.79a1.28,1.28,0,0,0,1.26,1.47h.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M52.38,53.56H46.69a16.7,16.7,0,0,0,0,11.16h5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M77.1,53.56h5.7a16.86,16.86,0,0,1,0,11.16H77.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M79.09,53.14c.52-7.68-4-15.36-14.29-15.36S50.88,45.46,50.51,53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-044-2",
    x: 71.73,
    y: 73.26,
    width: 5.58,
    height: 2.85,
    transform: "translate(-29.2 55.35) rotate(-34.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M77.1,72.81c1.56-1,2.9-3.93,2.58-7.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M22.32,117.35l12.14-16.42c.93-1.25,2.31-2.93,3.82-3.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M12.1,103.89,27.52,86.22c.25-.51.48-6,.7-8.77a12.87,12.87,0,0,1,3.69-7.39c.67-.7,1.51-1.62,1.73-1.88A7.32,7.32,0,0,0,35.18,65c.42-1.91,1-4.88,1.18-6.4a2.06,2.06,0,0,1,2.07-2.07,2.44,2.44,0,0,1,2.39,2.07A14.88,14.88,0,0,1,41.15,64a20.26,20.26,0,0,1-1.93,5.63C38.28,72,44.36,79.54,36,88.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M105.68,117.35,93.54,100.93c-.93-1.25-2.31-2.93-3.82-3.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-044-2",
    d: "M115.9,103.89,100.48,86.22c-.25-.51-.48-6-.7-8.77a12.87,12.87,0,0,0-3.69-7.39c-.67-.7-1.51-1.62-1.73-1.88A7.32,7.32,0,0,1,92.82,65c-.42-1.91-1-4.88-1.18-6.4a2.06,2.06,0,0,0-2.07-2.07,2.44,2.44,0,0,0-2.39,2.07A14.88,14.88,0,0,0,86.85,64a20.26,20.26,0,0,0,1.93,5.63c.94,2.3-5.14,9.87,3.19,18.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-044-6",
    width: 128,
    height: 128
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128044);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_044.2af4c45dceb43d5e4f9da0ea27698619.svg";
export { ForwardRef as ReactComponent };